import React from 'react';
import { Card, Button } from 'antd';
import { WarningOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import type { MerchantAlert } from '../../types/dashboardFounder';
import { ChartSkeleton } from '../dashboard/ChartSkeleton';
import { DashboardEmptyState } from '../dashboard/DashboardEmptyState';

interface MerchantRiskAlertsProps {
  alerts: MerchantAlert[];
  loading?: boolean;
}

const SEVERITY_ICON: Record<string, React.ReactNode> = {
  warning: <WarningOutlined style={{ color: '#f59e0b' }} />,
  error: <ExclamationCircleOutlined style={{ color: '#ef4444' }} />,
  info: <ExclamationCircleOutlined style={{ color: '#3b82f6' }} />,
};

export const MerchantRiskAlerts: React.FC<MerchantRiskAlertsProps> = ({
  alerts,
  loading = false,
}) => {
  if (loading) {
    return (
      <Card className="founder-chart-card" style={{ borderRadius: 12 }}>
        <h3 className="founder-chart-title">Merchant Risk Alerts</h3>
        <ChartSkeleton height={280} />
      </Card>
    );
  }

  if (!alerts.length) {
    return (
      <Card className="founder-chart-card" style={{ borderRadius: 12 }}>
        <h3 className="founder-chart-title">Merchant Risk Alerts</h3>
        <DashboardEmptyState
          message="Không có cảnh báo"
          suggestion="Các merchant đều hoạt động bình thường trong khoảng thời gian đã chọn."
        />
      </Card>
    );
  }

  return (
    <Card className="founder-chart-card" style={{ borderRadius: 12 }}>
      <h3 className="founder-chart-title">Merchant Risk Alerts</h3>
      <div className="founder-alerts-list">
        {alerts.map((alert, i) => (
          <div key={`${alert.merchantId}-${i}`} className="founder-alert-item">
            <div className="founder-alert-icon">
              {SEVERITY_ICON[alert.severity] ?? <WarningOutlined />}
            </div>
            <div className="founder-alert-content">
              <div className="founder-alert-merchant">{alert.name}</div>
              <div className="founder-alert-message">{alert.message}</div>
              <Link to={`/merchants/${alert.merchantId}`}>
                <Button type="link" size="small" className="founder-alert-cta">
                  View merchant
                </Button>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};
